import PropTypes from "prop-types";
import React from "react";
import { Card, CardBody, Col, Label, Row } from "reactstrap";

const readOnlyInput = value => (
  <input type="text" className="form-control" value={value || ""} readOnly />
);

const StatementParties = props => {
  const { seller, buyer } = props;

  return (
    <Card>
      <CardBody>
        <Row>
          <Col md="6" className="border-end">
            <div className="text-uppercase fw-bold font-size-12 text-primary mb-3">
              Bên bán (công ty)
            </div>
            <Label className="font-size-12 text-muted mb-1">Tên công ty</Label>
            {readOnlyInput(seller?.name)}
            <Row className="mt-3">
              <Col md="4">
                <Label className="font-size-12 text-muted mb-1">
                  Mã số thuế
                </Label>
                {readOnlyInput(seller?.tax_code)}
              </Col>
              <Col md="8">
                <Label className="font-size-12 text-muted mb-1">Địa chỉ</Label>
                {readOnlyInput(seller?.address)}
              </Col>
            </Row>
          </Col>

          <Col md="6">
            <div className="text-uppercase fw-bold font-size-12 text-primary mb-3">
              Và công ty (bên mua)
            </div>
            <Label className="font-size-12 text-muted mb-1">Tên công ty</Label>
            {readOnlyInput(buyer?.name)}
            <Row className="mt-3">
              <Col md="4">
                <Label className="font-size-12 text-muted mb-1">
                  Mã số thuế
                </Label>
                {readOnlyInput(buyer?.tax_code)}
              </Col>
              <Col md="8">
                <Label className="font-size-12 text-muted mb-1">Địa chỉ</Label>
                {readOnlyInput(buyer?.address)}
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

StatementParties.propTypes = {
  seller: PropTypes.object,
  buyer: PropTypes.object,
};

StatementParties.defaultProps = {
  seller: null,
  buyer: null,
};

export default StatementParties;
